<template>

    <div role="tabpanel" aria-labelledby="effort-tab" class="tab-pane fade active show">

        <div v-if="timeEntries.length == 0" style="text-align:center">
            <p class="center">No Entries</p>
        </div>

        <ul class="list-data list-data-effort">
            <li v-for="entry in timeEntries" :key="entry.id">
                <div class="row g-0">
                    <div class="col">
                        <p><strong>{{ entry.user ? entry.user.name : '(Deleted User)'}}</strong><br>Spent {{entry.spent_hours_minutes.hours}} hours {{entry.spent_hours_minutes.minutes}} Minutes</p>
                    </div>

                    <div class="col-auto">
                        <button @click="onEditClick(entry)" type="button" class="btn btn-sm text-muted">
                            <i class="far fa-pencil-alt"></i>
                        </button>

                        <button @click="onDeleteClick(entry.id, entry.entry_date)" type="button" class="btn btn-sm text-danger">
                            <i class="far fa-trash-alt"></i>
                        </button>
                    </div>
                </div>
                <p class="text-muted">{{entry.entry_date | moment("DD/MM/YYYY")}}</p>
                <p class="text-muted">{{entry.reference}}</p>
            </li>
        </ul>
    </div>

</template>

<script>

    import { mapState, mapActions, mapGetters } from 'vuex'
    import UserSelect from 'components/form/input/_user-select'

    let timeModel = function() {
        return {
            hours: 0,
            minutes: 0,
            seconds: 0
        }
    }

    export default {
        props: ['propItem'],

        computed: {
            ...mapGetters('yodizproject/effort', {
                getEfforyByItemId: 'getByItemId'
            }),

            timeEntries() {
                let type = ""
                let id = "";

                if (this.propItem.id.includes('tk')) {
                    type = 'Carbon\\Yodiz\\Task'
                    id = this.propItem.id.replace('tk-', '')
                } else if (this.propItem.id.includes('bg')) {
                    type = 'Carbon\\Yodiz\\Issue'
                    id = this.propItem.id.replace('bg-', '')
                }

                return this.getEfforyByItemId(id, type)
            },
        },
        methods: {

            ...mapActions('yodizproject/effort', {
                focusEffortLogItem: 'setSingle',
                deleteEffortLog: 'deleteListObject'
            }),

            ...mapActions('yodizproject/stories', {
                setStoryListProperty: 'setSingleListProperty'
            }),

            ...mapActions('yodizproject/tasks', {
                setTaskListProperty: 'setSingleListProperty'
            }),

            onEditClick(entry) {

                this.focusEffortLogItem(entry)

                this.$emit('update-entry', entry.id);
            },

            onDeleteClick(id, entry_date) {

                let date = moment(entry_date);

                this.$swal(
                    {
                        title: 'Confirm Delete',
                        html: `Are you sure you want to delete the entry recorded on: ${date.format("DD/MM/YY h:mm a")}`,
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Delete',
                    }).then( () => {
                        this.deleteEffortLog({id:id}).then((response) => {

                            //The API should return story and task partials so we don't have to make multiple requests
                            if (response.data) {
                                if (response.data.hasOwnProperty('story')) {
                                    this.setStoryListProperty({ id: response.data.story.id, property: 'time_entries_total', value: response.data.story.time_entries_total })
                                }

                                if (response.data.hasOwnProperty('item')) {
                                    this.setTaskListProperty({ id: response.data.item.id, property: 'time_entries_total', value: response.data.item.time_entries_total })
                                }
                            }
                        })
                    }, function() {
                });

                //Hack to stop bootstrap menu closing when clicking on the sweetalert
                $(document).on('click', '.swal2-container', function (e) {
                    e.stopPropagation();
                    //Remove this listener so we are not duplicating
                    $(document).off('click', '.swal2-container');
                });
            }
        }
    }
</script>

